/**
 * GitHub's permission name (`deployments=read`, possibly several separated by
 * commas) in the form GitHub's token settings show it: `Deployments: Read`.
 */
export function formatGithubPermission(permission: string): string {
  const title = (word: string) => word.charAt(0).toUpperCase() + word.slice(1).replace(/_/g, ' ');
  return permission
    .split(/[,;]\s*/)
    .filter((part) => part.trim() !== '')
    .map((part) => {
      const [scope = '', level = ''] = part.trim().split('=');
      return level ? `${title(scope)}: ${title(level)}` : title(scope);
    })
    .join(', ');
}
